package presentation.screens.common.address_screen.create

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import component.button.DefaultButton
import component.input.TextInputField
import component.navigation.TopNavBar
import feature.address.handler.AddressHandler
import feature.address.viewModel.AddressViewModel
import feature.auth.model.FriendlyUser
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock

class CreateAddressScreen : Screen {

    val user = FriendlyUser()


    var mobileNumber: String = ""
    var houseNumber: String = ""
    var area: String = ""
    var landmark: String = ""
    var pincode: String = ""
    var cityName: String = ""
    var state: String = ""


    fun onClickSave() {
        val viewModel = AddressViewModel()
        val unixTime = Clock.System.now().epochSeconds
//        val addressObject = JsonObject()
//        addressObject.put(KeyConstant.mobileNumber, mobileNumber)
//        addressObject.put(KeyConstant.featureObjectID, user._id)
//        addressObject.put(KeyConstant.dialCode, AuthHandler.shared().countryCode?.countryPhoneCode)
//        addressObject.put(KeyConstant.dialCode, "")
//        addressObject.put(KeyConstant.userId, user._id)
//        addressObject.put(KeyConstant.uniqueId, unixTime)
//        addressObject.put(KeyConstant.house, houseNumber)
//        addressObject.put(KeyConstant.area, area)
//        addressObject.put(KeyConstant.city, cityName)
//        addressObject.put(KeyConstant.zipCode, pincode)
//        addressObject.put(KeyConstant.state, state)
//        addressObject.put(KeyConstant.landMark, landmark)
//        viewModel.createNew(addressObject)
    }

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.current
        val mobileErrorState = remember {
            mutableStateOf(false)
        }
        AddressHandler.shared().onCreateResponse =
            {
                val scope = CoroutineScope(Job() + Dispatchers.Main)
                scope.launch {
                    navigator?.pop()
                }
            }
        Column(modifier = Modifier.fillMaxHeight()) {
            TopNavBar("Create Address", onBackPress = {
                navigator?.pop()
            })
//        MobileTextField(
//            placeholder = "Mobile Number",
//            trailingIcon = R.drawable.phone,
//            label = "Mobile Number",
//            keyboardType = KeyboardType.Phone,
//            visualTransformation = VisualTransformation.None,
//            onChanged = {
//                mobileNumber = it.text
//            },
//            errorState = mobileErrorState
//        )
            TextInputField(
                placeholder = "House Number",
                onChange = {
                    houseNumber = it
                }
            )
            TextInputField(
                placeholder = "Block/Area/Village/Locality",
                onChange = {
//                    KeyConstant.area = it
                }
            )
            TextInputField(
                placeholder = "LandMark",
                onChange = {
                    landmark = it
                }
            )
            TextInputField(
                placeholder = "Pincode/Zipcode",
                onChange = {
                    pincode = it
                }
            )
            TextInputField(
                placeholder = "City",
                onChange = {
                    cityName = it
                }
            )
            TextInputField(
                placeholder = "State",
                onChange = {
//                    KeyConstant.state = it
                }
            )
            DefaultButton(
                title = "Save",
                onClick = { onClickSave() },
                modifier = Modifier.fillMaxWidth()
            )
        }
    }
}